export default {
    awesome_ads_direct: 1,
    awesome_ads_deal: 2
}